import { getLinks, AcceptedLinksStarts } from '@cinch-nx/data-storyblok'
import { GetStaticPathsResult } from 'next/types'
import { brandStaticPaths } from './storyblok/data/landing-brands-feature.data'

export const getStaticPathsGenerator =
  (slug: string) => async (): Promise<GetStaticPathsResult> => {
    try {
      const links = await getLinks(slug as AcceptedLinksStarts)
      const paths = brandStaticPaths({ links })
      return { paths, fallback: 'blocking' }
    } catch {
      return { paths: [], fallback: 'blocking' }
    }
  }
